<template>
  <NuxtLink v-bind="$attrs" class="text-blue-500 underline">
    <slot />
  </NuxtLink>
</template>
